/* eslint-disable import/no-named-as-default-member */
import React from 'react'
import _ from 'lodash'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { Icon, Label } from 'semantic-ui-react'
import { connect } from 'react-redux'
import firebase from '../../../config/firebase'
import RestaurantActions from '../../../reducers/restaurantReducer'

class TagsDraggable extends React.PureComponent {
  state = {
    saving: false,
    hasArranged: false,
    arrangeTags: [],
  }

  componentDidMount() {
    const { storeTags, allTags } = this.props

    this.generateArrangeTags(storeTags, allTags)
  }

  componentWillReceiveProps(nextProps) {
    const { storeTags, allTags } = this.props

    if (allTags !== nextProps.allTags && nextProps.storeTags) {
      this.generateArrangeTags(nextProps.storeTags, nextProps.allTags)
    }

    if (storeTags !== nextProps.storeTags && nextProps.storeTags) {
      this.generateArrangeTags(nextProps.storeTags, nextProps.allTags)
    }
  }

  generateArrangeTags = (storeTags, allTags) => {
    let tagsList = _.map(storeTags, (tag, tagKey) => {
      return {
        name: allTags[tagKey],
        ...tag,
        tagKey,
      }
    })

    tagsList = _.orderBy(tagsList, tag => tag.listing_number, ['asc'])

    const arrangeTags = _.map(tagsList, tag => ({
      id: tag.tagKey,
      content: tag.name,
      order: tag.listing_number || '',
      tagName: tag.name,
    }))

    this.setState({ arrangeTags, hasArranged: false })
  }

  getListStyle = () => ({
    width: 250,
    borderRadius: 10,
  })

  getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    padding: 10,
    margin: `4px 0 4px 0`,
    width: '100%',
    borderRadius: `5px`,
    background: isDragging ? 'black' : '#e0e1e2',
    color: isDragging ? 'white' : 'rgba(0,0,0,.8)',
    ...draggableStyle,
  })

  onSaveClick = () => {
    const { arrangeTags } = this.state
    const { storeId, setEditable, fetchStore } = this.props
    const updates = {}

    const conf = window.confirm('Are you sure to update tags list order?')

    if (conf) {
      _.map(arrangeTags, (tag, index) => {
        updates[`restaurants/${storeId}/tags/${tag.id}/listing_number`] = index + 1
      })

      this.setState({ saving: true })

      firebase
        .database()
        .ref()
        .update(updates)
        .then(err => {
          if (err) {
            alert(err)
          }

          this.setState(
            {
              saving: false,
              hasArranged: false,
            },
            () => {
              setEditable()
              fetchStore(storeId)
            }
          )
        })
    }
  }

  onDragEnd = result => {
    const { arrangeTags } = this.state

    if (!result.destination) {
      return
    }

    const items = this.reorder(arrangeTags, result.source.index, result.destination.index)

    this.setState({
      arrangeTags: items,
      hasArranged: true,
    })
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)

    const [removed] = result.splice(startIndex, 1)

    result.splice(endIndex, 0, removed)

    return result
  }

  renderTagsItems = () => {
    const { arrangeTags } = this.state

    return _.map(arrangeTags, (tag, index) => {
      return (
        <Draggable key={tag.id} draggableId={tag.id} index={index}>
          {(dragProvided, snapshot) => {
            return (
              <div
                ref={dragProvided.innerRef}
                {...dragProvided.draggableProps}
                {...dragProvided.dragHandleProps}
                style={this.getItemStyle(snapshot.isDragging, dragProvided.draggableProps.style)}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    flex: 1,
                  }}
                >
                  <div style={{ marginRight: 20 }}>
                    {tag.order !== '' && (
                      <Label color="red" horizontal>
                        {tag.order}
                      </Label>
                    )}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flex: 1,
                      flexDirection: 'column',
                    }}
                  >
                    <div>{tag.content}</div>
                  </div>
                  <div style={{ marginLeft: 20 }}>
                    <Icon name="align justify" />
                  </div>
                </div>
              </div>
            )
          }}
        </Draggable>
      )
    })
  }

  render() {
    const { hasArranged, saving } = this.state
    const { setEditable } = this.props

    return (
      <div>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {dropProvided => (
              <div
                ref={dropProvided.innerRef}
                style={this.getListStyle()}
                className="droppable-tags"
                {...dropProvided.droppableProps}
              >
                {this.renderTagsItems()}
                {dropProvided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <Label
          onClick={this.onSaveClick}
          loading={saving}
          disabled={!hasArranged || saving}
          color="black"
          style={{ marginTop: 10, cursor: 'pointer' }}
        >
          Save
        </Label>
        <Label
          disabled={saving}
          onClick={setEditable}
          color="black"
          style={{ marginTop: 10, cursor: 'pointer' }}
        >
          Back
        </Label>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  fetchStore: id => dispatch(RestaurantActions.fetchRestaurantRequest(id)),
})

export default connect(
  null,
  mapDispatchToProps
)(TagsDraggable)



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/tagsRearrangeField.js